import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { server } from '../app/conf'
@Injectable({
  providedIn: 'root'
})
export class PersonalDetailsService {

  constructor(
    private http:HttpClient
  ) { }
  create(personalDetails){
    return this.http.post<any>(`${server}personaldetails`,personalDetails);
  }
  update(_id:string,personalDetails){
    return this.http.put<any>(`${server}personaldetails/${_id}`,personalDetails);
  }
  find(){
    return this.http.get<any[]>(`${server}personaldetails`);
  }
  findForCde(accessToken){
    return this.http.get<any[]>(`${server}personaldetailsforcde?access_token=${accessToken}`);
  }  
}
